import { api, wire } from "lwc";

import Card, { CtaEvent } from "tds/card";

import { EffectAdapter } from "common/effectAdapter";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import * as locales from "./locales";

export type Layout = "stack" | "grid";

export default class extends Card {
  @api layout: Layout = "stack";

  private get ctaLabelViewMore() {
    return this.ctaLabel ?? (this.ctaHref ? this.labels.viewMore : null);
  }

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = {};

  private handleCta(event: CtaEvent) {
    this.dispatchEvent(new CustomEvent(event.type, { detail: event.detail }));
  }

  @wire(EffectAdapter, { layout: "$layout" })
  private onUpdateLayout() {
    this.template.host.setAttribute("data-layout", this.layout);
  }
}
